import { render, staticRenderFns } from "./fundsInterests.vue?vue&type=template&id=1d2ee479"
import script from "./fundsInterests.vue?vue&type=script&lang=js"
export * from "./fundsInterests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports